import { getHost } from './getHost';
import { getSchema } from './getSchema';

export const getSchemaHost = () => `${getSchema()}//${getHost()}`;
